// Version : 0.0.1
// Author : SABARI

import MemberMandatoryAccessActionTypes from './member-mandatory-access.types';

/** ***************** GET Member Mandatory Access DETAILS START *********************** */
export const fetchMemberMandatoryAccessStart = (getData: any) => ({
	type: MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_START,
	payload: getData,
});

export const fetchMemberMandatoryAccessSuccess = (successData: any) => ({
	type: MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_SUCCESS,
	payload: successData,
});

export const fetchMemberMandatoryAccessFailure = (failureData: any) => ({
	type: MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_FAILURE,
	payload: failureData,
});

export const fetchMemberMandatoryAccessResponseReset = () => ({
	type: MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_RESPONSE_RESET,
});

export const fetchMemberMandatoryAccessResponseChanged = () => ({
	type: MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_RESPONSE_CHANGED,
});
/** ***************** GET Member Mandatory Access DETAILS END *********************** */

/** ***************** UPDATE Member Mandatory Access DETAILS START *********************** */
export const updateMemberMandatoryAccessStart = (getData: any) => ({
	type: MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_START,
	payload: getData,
});

export const updateMemberMandatoryAccessSuccess = (successData: any) => ({
	type: MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_SUCCESS,
	payload: successData,
});

export const updateMemberMandatoryAccessFailure = (failureData: any) => ({
	type: MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_FAILURE,
	payload: failureData,
});

export const updateMemberMandatoryAccessResponseReset = () => ({
	type: MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_RESPONSE_RESET,
});

export const updateMemberMandatoryAccessResponseChanged = () => ({
	type: MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_RESPONSE_CHANGED,
});

/** ***************** UPDATE Member Mandatory Access DETAILS END *********************** */
